import { Alignment, Button, Direction, Displaying, FontWeight, Spacing, Typography } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import type { FallbackProps } from "react-error-boundary";
import { BACK_TO_HOMEPAGE_TEXT, UNEXPECTED_ERROR_TITLE_TEXT } from "../../../constants/commonStrings";
import { WELCOME_PATH } from "../../../constants/env";
import { AuthenticationService } from "../../../legacy/services/authentication-service/authentication.service";
import type { IAuthenticationService } from "../../../legacy/services/authentication-service/authentication.service.interface";
import { isAuthError } from "../../../lib/auth-error/is-auth-error";

const authenticationService: IAuthenticationService = new AuthenticationService();

function handleBackToHomepage(): void {
  window.location.assign("/");
}

function ErrorBoundaryFallback({ error }: Readonly<FallbackProps>): JSX.Element {
  useEffect(
    function cleanupSessionOnAuthError() {
      if (!isAuthError(error)) {
        return;
      }
      authenticationService
        .logoutAndResetStorage()
        .catch(console.error)
        .finally(function redirectToWelcome() {
          window.location.assign(WELCOME_PATH);
        });
    },
    [error]
  );

  return (
    <Box
      display={Displaying.flex}
      flexDirection={Direction.column}
      alignItems={Alignment.center}
      gap={Spacing["2000"]}
      paddingX={Spacing["1500"]}
      paddingY={Spacing["4500"]}
      textAlign="center"
    >
      <Typography variant="h3" fontWeight={FontWeight.bold}>
        {UNEXPECTED_ERROR_TITLE_TEXT}
      </Typography>
      <Button variant="outlined" color="primary" size="large" onClick={handleBackToHomepage}>
        {BACK_TO_HOMEPAGE_TEXT}
      </Button>
    </Box>
  );
}

export default ErrorBoundaryFallback;
